export default __webpack_public_path__ + "static/media/progress_icon.378bf7b6.svg";